@if (germanAMLChangesEnabled && instrumentFormGroup.controls.productPreferenceFormGroup) {
    <app-product-preference [productPreferenceFormGroup]="instrumentFormGroup.controls.productPreferenceFormGroup" />
}
<div class="instrumentList">
    <form [formGroup]="instrumentFormGroup" class="form-control-wrapper options-list-dropdown mt-10">
        @if (!userData?.configParams?.pixBrInfo?.isNewBrLabel) {
            <mat-label class="pm-select-label text-bold">{{ 'PARTY.CASHIER.web.deposit.select.pm' | translate }}</mat-label>
        }
        <mat-form-field class="payment-method-options" [class.nolabel]="userData?.configParams?.pixBrInfo?.isNewBrLabel">
            <mat-select
                class="payment-option"
                formControlName="instrumentFormCtrl"
                id="instrumentFormCtrl"
                (selectionChange)="onChange($event)"
                disableOptionCentering>
                <mat-select-trigger>
                    <option-content
                        class="d-flex"
                        [usedOption]="selectedPaymentMethod"
                        [isUSLabel]="isUSLabel"
                        [class.disabled]="selectedPaymentMethod?.ESIntensiveGreyOut || selectedPaymentMethod?.isESRiskPlayer"></option-content>
                    @if (selectedPaymentMethod?.ESIntensiveGreyOut) {
                        <div class="drop-down-option-position position-absolute d-flex align-items-center">
                            <span class="txt-sm-v2 mr-1">{{ 'PARTY.CASHIER.web.deposit.intensive.player.message' | translate }}</span>
                            <span
                                class="theme-info-i"
                                (click)="$event.stopPropagation(); isIntensivePlayer()"
                                (mouseenter)="$event.stopPropagation(); isIntensivePlayer()"
                                [popper]="tooltipcontent2"
                                [popperPositionFixed]="true"
                                [popperTrigger]="isMobile ? NgxPopperjsTriggers.click : NgxPopperjsTriggers.hover"
                                [popperPlacement]="NgxPopperjsPlacements.BOTTOM"></span>
                        </div>
                    }
                    <popper-content class="tooltip-info ngxp__tooltip" #tooltipcontent2>
                        <div class="intensive-player-message th-scroll">
                            <strong class="h6-v2">{{ 'PARTY.CASHIER.web.deposit.intensive.player.message1' | translate }}</strong>
                            <p class="tooltip-description" [vnDynamicHtml]="'PARTY.CASHIER.web.deposit.intensive.player.message2' | translate"></p>
                            <a (click)="moreInfoLink()" class="popper-buttons tooltip-description">
                                <span class="popper-close-link dh">{{ 'PARTY.CASHIER.web.deposit.intensive.player.message3' | translate }}</span>
                            </a>
                        </div>
                    </popper-content>
                </mat-select-trigger>
                @for (usedOption of usedOptions; track usedOption; let i = $index) {
                    <mat-option
                        [disabled]="
                            (maxFailDepEnhancementEnabled && usedOption?.userMaxFailDepStatus?.blocked) ||
                            usedOption?.ESIntensiveGreyOut ||
                            usedOption?.isESRiskPlayer
                        "
                        class="p-0 payment-option-list"
                        [value]="usedOption">
                        <option-content
                            [class.disabled]="
                                (maxFailDepEnhancementEnabled && usedOption?.userMaxFailDepStatus?.blocked) ||
                                usedOption?.ESIntensiveGreyOut ||
                                usedOption?.isESRiskPlayer
                            "
                            class="d-flex"
                            [usedOption]="usedOption"
                            [isUSLabel]="isUSLabel"></option-content>
                        @if (maxFailDepEnhancementEnabled && usedOption?.userMaxFailDepStatus?.blocked) {
                            <div class="mfde-alignment position-absolute d-flex align-items-center">
                                <span class="txt-sm-v2 mr-1">{{ 'PARTY.CASHIER.web.deposit.mfde.paused' | translate }}</span>
                                <span
                                    class="theme-info-i"
                                    (click)="$event.stopPropagation()"
                                    [popper]="tooltipcontent"
                                    [popperPositionFixed]="true"
                                    [popperTrigger]="isMobile ? NgxPopperjsTriggers.click : NgxPopperjsTriggers.hover"
                                    [popperPlacement]="NgxPopperjsPlacements.BOTTOM"></span>
                            </div>
                        }
                        @if (usedOption?.ESIntensiveGreyOut) {
                            <div class="drop-down-option-position position-absolute d-flex align-items-center">
                                <span class="txt-sm-v2 mr-1">{{ 'PARTY.CASHIER.web.deposit.intensive.player.message' | translate }}</span>
                                <span
                                    class="theme-info-i"
                                    (click)="$event.stopPropagation(); isIntensivePlayer()"
                                    (mouseenter)="$event.stopPropagation(); isIntensivePlayer()"
                                    [popper]="tooltipcontent1"
                                    [popperPositionFixed]="true"
                                    [popperTrigger]="isMobile ? NgxPopperjsTriggers.click : NgxPopperjsTriggers.hover"
                                    [popperPlacement]="NgxPopperjsPlacements.BOTTOM"></span>
                            </div>
                        }
                    </mat-option>
                    <popper-content class="tooltip-info ngxp__tooltip" id="tooltipcontent{{ i }}" #tooltipcontent>
                        <div class="curfew-blue">
                            <strong class="h6-v2">{{ 'PARTY.CASHIER.web.deposit.mfde.payment.method.hold.header' | translate }}</strong>
                            <p class="tooltip-description">
                                <span class="txt-sm-v2"
                                    >{{
                                        'PARTY.CASHIER.web.deposit.mfde.payment.method.hold.tooltip'
                                            | translate
                                                : {
                                                      time: usedOption?.userMaxFailDepStatus?.blockEndTime,
                                                      date: usedOption?.userMaxFailDepStatus?.blockEndDate,
                                                  }
                                    }}
                                </span>
                            </p>
                        </div>
                    </popper-content>
                    <popper-content class="tooltip-info ngxp__tooltip" id="tooltipcontent{{ i }}" #tooltipcontent1>
                        <div class="intensive-player-message th-scroll">
                            <strong class="h6-v2">{{ 'PARTY.CASHIER.web.deposit.intensive.player.message1' | translate }}</strong>
                            <p class="tooltip-description" [vnDynamicHtml]="'PARTY.CASHIER.web.deposit.intensive.player.message2' | translate"></p>
                            <a (click)="moreInfoLink()" class="popper-buttons tooltip-description">
                                <span class="popper-close-link dh">{{ 'PARTY.CASHIER.web.deposit.intensive.player.message3' | translate }}</span>
                            </a>
                        </div>
                    </popper-content>
                }
                <mat-option [value]="'allDepositOptions'" class="p-0">
                    <div class="d-flex align-items-center">
                        <div class="payment-method-logo payment-method-moreoptions"></div>
                        <p class="all-payment-option">{{ 'PARTY.CASHIER.web.deposit.more.options' | translate }}</p>
                    </div>
                </mat-option>
            </mat-select>
        </mat-form-field>
        <!-- Bank Account Registration PIX flow -->
        @if (selectedPaymentMethod?.paymentMethod?.toUpperCase() == 'PIX' && this.pixBankRegistration.isEnabled) {
            <div class="pix-bank-account-wrapper">
                <mat-label class="pm-select-label text-bold d-inline-block"
                    >{{ 'PARTY.CASHIER.web.deposit.pix.bankaccount.label' | translate }}
                    <img
                        src="assets/images/PixInfo.svg"
                        class="cursor-pointer ml-2"
                        [popper]="tooltipcontent"
                        [popperPositionFixed]="true"
                        [popperTrigger]="NgxPopperjsTriggers.click"
                        [popperPlacement]="NgxPopperjsPlacements.BOTTOM"
                        [popperApplyClass]="'popperSpecialStyle'" />
                </mat-label>
                <popper-content class="tooltip-info ngxp__tooltip" #tooltipcontent>
                    <div class="tooltip-description">
                        {{ 'PARTY.CASHIER.web.deposit.pix.bankaccount.tooltip' | translate }}
                    </div>
                </popper-content>
                <mat-form-field>
                    <mat-select
                        formControlName="pixAccountSelect"
                        name="pixAccountSelect"
                        panelClass="pix-bank-account-select"
                        (selectionChange)="onPixAccountChange($event)">
                        <mat-select-trigger class="pix-select-trigger">
                            {{ pixBankRegistration.selectedInfo?.bankName }}
                        </mat-select-trigger>
                        @for (bank of selectedPaymentMethod?.BANK_INSTRUMENT_LIST; track bank) {
                            <mat-option [value]="bank">
                                <div class="bank-option d-flex flex-column">
                                    <div class="bank-name">{{ bank?.bankName }}</div>
                                    <div class="bank-details">
                                        {{ 'PARTY.CASHIER.web.deposit.pix.branchcode' | translate }} {{ bank?.branchCode }} &nbsp;&nbsp;|&nbsp;&nbsp;
                                        {{ 'PARTY.CASHIER.web.deposit.pix.account' | translate }} {{ bank?.accountNumber | accountMaskPipe }}
                                    </div>
                                </div>
                            </mat-option>
                        }
                        <div
                            (click)="redirectToMainCashier()"
                            class="pix-account-actions d-flex align-items-center justify-content-between py-2 px-3 cursor-pointer"
                            [ngClass]="{ 'border-0': selectedPaymentMethod?.BANK_INSTRUMENT_LIST?.length == 1 }">
                            <a href="javascript:void(0)" class="text-decoration-none">
                                {{
                                    (selectedPaymentMethod &&
                                    selectedPaymentMethod.BANK_INSTRUMENT_LIST &&
                                    userData &&
                                    userData.configParams &&
                                    selectedPaymentMethod.BANK_INSTRUMENT_LIST.length >= userData.configParams.bank_registration_allowed_count
                                        ? 'PARTY.CASHIER.web.deposit.pix.manageAccounts'
                                        : 'PARTY.CASHIER.web.deposit.pix.newAccount'
                                    ) | translate
                                }}
                            </a>
                            <span class="ui-icon ui-icon-size-sm float-right ui-close theme-right"></span>
                        </div>
                    </mat-select>
                </mat-form-field>
            </div>
        }

        @if (ccDepositLimitCheckEnabled && optionListService.selectedOption.creditCard) {
            <show-message id="creditcard_deposit_limit_message2" [type]="messageType.INFO">
                <p
                    info
                    [vnDynamicHtml]="
                        'PARTY.CASHIER.web.deposit.ny.creditcard.deposit.limit.annual.message'
                            | translate
                                : {
                                      annualLimit: +ccCurrentDepositLimit | vnCurrency: currencyUSD,
                                  }
                    "></p>
            </show-message>
        }

        @if (isInstantEchecks) {
            <div>
                <input
                    type="hidden"
                    name="vipPreferredAccountNumber"
                    [(ngModel)]="depositService.depositInfo.paymentAccountInfo.vipPreferredAccountNumber" />
                <b>
                    <span>
                        {{
                            'PARTY.CASHIER.web.deposit.instantechecks.accountbalance.msg'
                                | translate
                                    : {
                                          accountbalanceInfo:
                                              optionListService?.selectedOption?.accountBalance
                                              | vnCurrency
                                                  : optionListService?.selectedOption?.paymentMethodInfo?.minDepositLimit?.currencyCode?.toUpperCase()
                                                  : '1.2-2',
                                      }
                        }}
                    </span>
                </b>
            </div>
        }

        @if (prepaidCards.includes(inputType.toUpperCase())) {
            <div class="text-bold">
                {{
                    'PARTY.CASHIER.web.deposit.prepaidcard.accountbalance.msg'
                        | translate
                            : {
                                  accountbalanceInfo:
                                      optionListService?.selectedOption?.accountBalance
                                      | vnCurrency
                                          : optionListService?.selectedOption?.paymentMethodInfo?.minDepositLimit?.currencyCode?.toUpperCase()
                                          : '1.2-2',
                              }
                }}
            </div>
        }

        @if (depositRedirectService?.redirectMessage) {
            <app-redirect-message />
        }
    </form>

    <div
        class="clear-both"
        [ngClass]="ccFamily.includes(inputType.toUpperCase()) ? 'space-between-width-50' : 'non-cc-amt-field'"
        [class.disabled]="!!(selectedPaymentMethod?.ESIntensiveGreyOut || selectedPaymentMethod?.isESRiskPlayer)">
        @if (optionListService.selectedOption && optionListService.selectedOption.paymentMethodInfo?.paymentMethod != 'FLASH1VOUCHER') {
            <app-amount [amountFormGroup]="amountFieldFormGroup" [selectedOption]="optionListService.selectedOption" />
        }

        @if (instrumentFormGroup.controls.instrumentInputFormGroup) {
            @if (ccFamily.includes(inputType.toUpperCase())) {
                <div class="cc-input">
                    <app-cc-input [ccInputFormGroup]="instrumentFormGroup.controls.instrumentInputFormGroup" />
                </div>
            }

            @if (inputType === 'FLASH1VOUCHER') {
                <div class="non-cc-amt-field">
                    <app-flash1-voucher-input [voucherInputFormGroup]="instrumentFormGroup.controls.instrumentInputFormGroup" />
                </div>
            }
        }
    </div>
    @if (depositInfo.isBelgiumRgDecreeEnabled && amountFieldFormGroup?.controls?.userAmount?.status === 'VALID' && rgLimitData) {
        <threshold-limit-messages />
    }
    @if (
        ((amountFieldFormGroup?.controls?.userAmount?.dirty || amountFieldFormGroup?.controls?.userAmount?.touched) &&
            optionListService?.selectedOption &&
            amountFieldFormGroup?.controls?.userAmount?.hasError('selfSetLimit')) ||
        enablePrepaidcardRestrictions ||
        amountFieldFormGroup?.controls?.userAmount?.hasError('spainRekycLimit') ||
        amountFieldFormGroup?.controls?.userAmount?.hasError('spainOdInlineVal')
    ) {
        <!-- incorrect typing in the component -->
        <app-deposit-limit-message [selectedOption]="optionListService.selectedOption" [amountFormGroup]="amountFieldFormGroup" />
    }

    @if (inputType === 'GAMERSCARD') {
        <app-password-block />
    }

    @if (!defaultCurrency) {
        <app-transaction-currency />
    }
</div>
